import { render } from "./HorizontalScroller.vue?vue&type=template&id=660ef43c"
import script from "./HorizontalScroller.vue?vue&type=script&lang=js"
export * from "./HorizontalScroller.vue?vue&type=script&lang=js"

import "./HorizontalScroller.vue?vue&type=style&index=0&id=660ef43c&lang=scss"

import exportComponent from "/builds/filmin/amff-2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__